import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, Button, Box, DialogActions, DialogContentText,
} from '@material-ui/core';

export default class Alert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '', body: '', yes: '', no: '',
    };
  }


  ok(title, body, yes = () => {}) {
    this.setState({
      title, body, yes,  
    });
    this.setOpen(true);
  }

  setOpen(bool) {
    this.setState({ open: bool });
  }


  render() {
    return (
      <Dialog open={this.state.open}>
        <DialogTitle>{this.state.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {this.state.body}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => {
              this.state.yes();
              this.setOpen(false);
            }}
          >
            OK
          </Button>
    
        </DialogActions>
      </Dialog>
    );
  }
}
